module.exports = __webpack_public_path__ + "static/media/Inter-SemiBold.19b57197.woff";